<template>
  <!-- <ServerPicker /> -->
  <HonorPicker />
  <ExtraOptionPicker />
</template>

<script setup>
import HonorPicker from "./pickers/HonorPick.vue";
import ServerPicker from "./pickers/ServerPicker.vue";
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";
import { computed, ref, onMounted } from "vue";

const { getGame, getGamePack } = useGameStore();
const { currentGamePackSlug, currentGameSlug } = useGameComposable();
const checkoutStore = useCheckoutStore();

const handleDetails = () => {
  checkoutStore.clearCheckout();

  checkoutStore.setServer(1);
  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setDetails({
    desiredHonour: 60000,
  });

  checkoutStore.setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};

handleDetails();
onMounted(() => {
  checkoutStore.setCalculating();
});
</script>
